import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ThumbDownSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ThumbDownSVG;
